import { FC } from "react";
import { Flex, Text } from "@smile2impress/components/relaunch";
import { CheckmarkOutlineIcon, Icon, Icons } from "@smile2impress/components";
import { UniversalTextElement } from "templates/relaunch/primitives/UniversalTextElement";

import { ListItemProps } from "./ListItem.types";

export const ListItem: FC<ListItemProps> = ({ title, icon, texts }) => {
    const iconComponent =
        typeof icon === "string" ? Icons[icon as keyof typeof Icons] : icon;

    return (
        <Flex
            direction={["row-reverse", "row-reverse", "column"]}
            gap={[4, 4, 2]}
        >
            {iconComponent && (
                <Flex>
                    <Icon
                        w={3}
                        h={3}
                        as={iconComponent}
                        color="base.bitterSweet"
                    />
                </Flex>
            )}

            <Flex direction="column" gap={1}>
                <UniversalTextElement
                    title={title}
                    text={""}
                    extraTitleStyles={{
                        fontWeight: "medium",
                        textTransform: "uppercase",
                        as: "h3",
                    }}
                />

                {Array.isArray(texts) && texts.length > 0 && (
                    <Flex direction="column" gap={1} mt={1}>
                        {texts.map((item, idx) => (
                            <Flex key={idx} gap="8px" align="flex-start">
                                <Icon
                                    as={CheckmarkOutlineIcon}
                                    w={2}
                                    h={2}
                                    color="base.bitterSweet"
                                    mt="2px"
                                />
                                <Text textStyle="body" color="text.base">
                                    {item}
                                </Text>
                            </Flex>
                        ))}
                    </Flex>
                )}
            </Flex>
        </Flex>
    );
};
